<template>
  <div>
    <Row :gutter="10">
      <i-col :md="24" :lg="24" style="margin-bottom: 10px;">
        <Card>
          <Alert banner closable>搜索支持全局搜索，多条件搜索时请使用“|”作为条件分隔符</Alert>
          <div class="search-con search-con-top">
            <Input class="search-input" v-model="searchVal" style="padding:5px;" placeholder="输入关键字全局搜索"
                   @on-enter="searchinput"/>
            <slot name="new_btn">
              <Button type="primary" @click="editModal('', 'post', '新增')" class="search-btn">新增</Button>
            </slot>
            <Button type="error" class="search-btn" @click="handlerDelete">批量删除</Button>
          </div>
          <Spin size="large" fix v-if="spinShow"></Spin>
          <Table v-loading.fullscreen.lock="fullscreenLoading" height="670" size="small" ref="selection" border
                 :columns="columns" :data="tableData"
                 @on-selection-change="handleSelectChange"></Table>
          <div style="margin: 10px; overflow: hidden">
            <div style="float: left;">
              <Page :total="pageTotal" :current="pageNum" :page-size="pageSize" :page-size-opts=[15,35,50,100]
                    show-sizer show-total @on-change="changePage" @on-page-size-change="handlePageSize">
              </Page>
            </div>
          </div>
          <Modal v-model="modalMap.modalVisible" :title="modalMap.modalTitle" :loading=true :footer-hide=true
                 :mask-closable=false>
            <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="100">
              <FormItem
                label="单位名称"
                prop="cname"
              >
                <Input
                  v-model="formValidate.cname"
                  placeholder="请输入单位名称"
                ></Input>
              </FormItem>
              <FormItem
                label="统一社会信用代码"
                prop="code"
              >
                <Input
                  v-model="formValidate.code"
                  placeholder="请输入统一社会信用代码"
                ></Input>
              </FormItem>
              <FormItem
                label="住址"
                prop="adress"
              >
                <Input
                  v-model="formValidate.adress"
                  placeholder="请输入住址"
                ></Input>
              </FormItem>
              <FormItem
                label="法定代表人"
                prop="legal"
              >
                <Input
                  v-model="formValidate.legal"
                  placeholder="请输入法定代表人"
                ></Input>
              </FormItem>
              <FormItem
                label="法人身份证"
                prop="legalcard"
              >
                <Input
                  v-model="formValidate.legalcard"
                  placeholder="请输入法人身份证"
                ></Input>
              </FormItem>
              <FormItem
                label="注册资本"
                prop="capital"
              >
                <Input
                  v-model="formValidate.capital"
                  placeholder="请输入注册资本"
                ></Input>
              </FormItem>
              <FormItem
                label="有效期起"
                prop="stime"
              >
                <DatePicker type="date" editable v-model="formValidate.stime" format="yyyy-MM-dd"
                            placement="bottom-end" placeholder="请选择有效期起"></DatePicker>
              </FormItem>
              <FormItem
                label="有效期止"
                prop="etime"
              >
                <DatePicker type="date" editable v-model="formValidate.etime" format="yyyy-MM-dd"
                            placement="bottom-end" placeholder="请选择有效期止"></DatePicker>
              </FormItem>
              <FormItem
                label="发证机关"
                prop="authority"
              >
                <Input
                  v-model="formValidate.authority"
                  placeholder="请输入发证机关"
                ></Input>
              </FormItem>
              <FormItem
                label="发证日期"
                prop="atime"
              >
                <DatePicker type="date" editable v-model="formValidate.atime" format="yyyy-MM-dd"
                            placement="bottom-end" placeholder="请选择发证日期"></DatePicker>
              </FormItem>
              <FormItem
                label="许可证编号"
                prop="licencecode"
              >
                <Input
                  v-model="formValidate.licencecode"
                  placeholder="请输入许可证编号"
                ></Input>
              </FormItem>
              <FormItem
                label="所属镇区"
                prop="villages"
              >
                <Input
                  v-model="formValidate.villages"
                  placeholder="请输入所属镇区"
                ></Input>
              </FormItem>
              <FormItem
                label="联系人"
                prop="linkman"
              >
                <Input
                  v-model="formValidate.linkman"
                  placeholder="请输入联系人"
                ></Input>
              </FormItem>
              <FormItem
                label="联系电话"
                prop="linkphone"
              >
                <Input
                  v-model="formValidate.linkphone"
                  placeholder="请输入联系电话"
                ></Input>
              </FormItem>
              <FormItem>
                <Button
                  type="primary"
                  @click="handleSubmit('formValidate')"
                >提交
                </Button>
                <Button
                  @click="handleReset('formValidate')"
                  style="margin-left: 8px"
                >重置
                </Button>
              </FormItem>
            </Form>
          </Modal>

        </Card>
      </i-col>
    </Row>
  </div>
</template>
<script>

import {
  getDispatchinfolist,
  operationDispatchinfo
} from '@/api/dispatch/dispatchinfo.js'
import { getsysparameterList } from '@/api/system/sys_parameter'
import { changePer } from '@/api/apply/apply'

let moment = require('moment')
export default {
  data () {
    return {
      pj: 'A',
      spinShow: false,
      fullscreenLoading: false,
      formValidate: {},
      searchVal: '',
      tableData: [],
      modalMap: {
        modalVisible: false,
        modalTitle: '新建'
      },
      tableSelectIdList: [],
      editModalData: '',
      pageNum: 1, // 当前页码
      pageTotal: 0, // 数据总数
      pageSize: 15, // 每页条数

      ruleValidate: {
        cname: [
          {
            required: true,
            message: '单位名称不能为空',
            trigger: 'blur'
          }
        ],
         code: [
          {
            required: true,
            message: '统一社会信用代码不能为空',
            trigger: 'blur'
          }
        ],
         adress: [
          {
            required: true,
            message: '住址不能为空',
            trigger: 'blur'
          }
        ],
         legal: [
          {
            required: true,
            message: '法定代表人不能为空',
            trigger: 'blur'
          }
        ],
         legalcard: [
          {
            required: true,
            message: '法人身份证不能为空',
            trigger: 'blur'
          }
        ],
         capital: [
          {
            required: true,
            message: '注册资本不能为空',
            trigger: 'blur'
          }
        ],
         stime: [
          {
            required: true,
            type: 'date',
            message: '请选择有效期起',
            trigger: 'change'
          }
        ],
         etime: [
          {
            required: true,
            type: 'date',
            message: '请选择有效期止',
            trigger: 'change'
          }
        ],
         authority: [
          {
            required: true,
            message: '发证机关不能为空',
            trigger: 'blur'
          }
        ],
         atime: [
          {
            required: true,
            type: 'date',
            message: '请选择发证日期',
            trigger: 'change'
          }
        ],
         licencecode: [
          {
            required: true,
            message: '许可证编号不能为空',
            trigger: 'blur'
          }
        ],
         villages: [
          {
            required: true,
            message: '所属镇区不能为空',
            trigger: 'blur'
          }
        ],
         linkman: [
          {
            required: true,
            message: '联系人不能为空',
            trigger: 'blur'
          }
        ],
         linkphone: [
          {
            required: true,
            message: '联系电话不能为空',
            trigger: 'blur'
          }
        ]
      },
      columns: [
        {
          type: 'selection',
          key: 'id',
          width: 60,
          fixed: 'left',
          align: 'center'
        },
        {
          title: '单位名称',
          key: 'cname',
          fixed: 'left',
          width: 230,
          align: 'center',
          sortable: true
        },
         {
          title: '统一社会信用代码',
          key: 'code',
          width: 180,
          align: 'center',
          sortable: true
        },
         {
          title: '住址',
          key: 'adress',
          width: 280,
          align: 'center',
          sortable: true
        },
         {
          title: '法定代表人',
          key: 'legal',
          width: 120,
          align: 'center',
          sortable: true
        },
         {
          title: '法人身份证',
          key: 'legalcard',
          width: 170,
          align: 'center',
          sortable: true
        },
         {
          title: '注册资本',
          key: 'capital',
          width: 120,
          align: 'center',
          sortable: true
        },
         {
          title: '有效期起',
          key: 'stime',
          width: 120,
          align: 'center',
          sortable: true
        },
         {
          title: '有效期止',
          key: 'etime',
          width: 130,
          fixed: 'right',
          align: 'center',
          sortable: true,
          render: (h, params) => {
            if (new Date(params.row.etime) < new Date()) {
              return h('div', [
                h('Tag', { props: { color: 'red' } }, params.row.etime)
              ])
            } else {
              return h('div', [
                h('div', params.row.etime)
              ])
            }
          }
        },

        {
          title: '发证机关',
          key: 'authority',
          width: 200,
          align: 'center',
          sortable: true
        },
         {
          title: '发证日期',
          key: 'atime',
          width: 120,
          align: 'center',
          sortable: true
        },
         {
          title: '许可证编号',
          key: 'licencecode',
          width: 180,
          fixed: 'left',
          align: 'center',
          sortable: true,
          render: (h, params) => {
            if (new Date(params.row.etime) < new Date()) {
              return h('div', [
                h('Tag', { props: { color: 'red' } }, params.row.licencecode)
              ])
            } else {
              return h('div', [
                h('div', params.row.licencecode)
              ])
            }
          }
        },
         {
          title: '所属镇区',
          key: 'villages',
          width: 120,
          align: 'center',
          sortable: true
        },
         {
          title: '联系人',
          key: 'linkman',
          width: 120,
          align: 'center',
          sortable: true
        },
         {
          title: '联系电话',
          key: 'linkphone',
          width: 120,
          align: 'center',
          sortable: true
        },
         {
          title: '操作人员',
          key: 'admincount',
          width: 110,
          fixed: 'right',
          align: 'center',
          sortable: true
        },
         {
          title: '用工人数',
          key: 'percount',
          width: 150,
          fixed: 'right',
          align: 'center',
          sortable: true
        },
        {
          title: '信用',
          key: 'level',
          width: 80,
          fixed: 'right',
          align: 'center',
          sortable: true
        },
         {
          title: '操作',
          key: 'handle',
          fixed: 'right',
          width: 180,
          align: 'center',
          render: (h, params) => {
            return h('div', [
              h(
                'Button',
                {
                  props: {
                    type: 'primary',
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.editModal(params.row, 'post', '修改')
                    }
                  }
                },
                '编辑'
              ),
              h(
                'Button',
                {
                  props: {
                    type: 'warning',
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.setlevel(params.row, 'post', '评级')
                    }
                  }
                },
                '评级'
              ),
              h(
                'Button',
                {
                  props: {
                    type: 'error',
                    size: 'small'
                  },
                  on: {
                    click: () => {
                      this.delData(params)
                    }
                  }
                },
                '删除'
              )
            ])
          }
        }
      ]
    }
  },
  methods: {
    getDispatchinfolist (key, value) {
      this.spinShow = true
      getDispatchinfolist(this.pageNum, this.pageSize, key, value).then(res => {
        if (res.data.code === 0) {
          this.pageTotal = res.data.count
          this.tableData = res.data.data
        } else {
          this.$Message.error(`${res.data.msg}`)
        }
        this.spinShow = false
      })
    },
    getParameterList () {
    },
    handleSelectChange (val) {
      let SelectIdList = []
      val.forEach(item => {
        SelectIdList.push(item.id)
      })
      this.tableSelectIdList = SelectIdList
    },
    closeModal () {
      this.dialog.show = false
    },
    changelevel (id, level) {
      operationDispatchinfo({ id: id, level: level }, 'put').then(res => {
        if (res.data.code === 0) {
          this.$Message.success(`${res.data.msg}`)
          if (this.searchVal) {
            this.getDispatchinfolist(this.searchVal)
          } else {
            this.getDispatchinfolist()
          }
          this.modalMap.modalVisible = false
        } else {
          this.$Message.error(`${res.data.msg}`)
        }
      })
    },
    setlevel (paramsRow, meth, mtitle) {
      this.$confirm(paramsRow.cname + '信用评价', (new Date()).getFullYear() + '年度', {
        confirmButtonText: 'C',
        cancelButtonText: 'B',
        center: true,
        type: 'warning',
        distinguishCancelAndClose: true
      }).then(() => {
        this.changelevel(paramsRow.id, 'C')
      }).catch(action => {
        if (action === 'cancel') {
          this.changelevel(paramsRow.id, 'B')
        } else {

        }
      })
    },
    editModal (paramsRow, meth, mtitle) {
      this.modalMap.modalVisible = true
      this.modalMap.modalTitle = mtitle
      this.editModalData = meth
      this.getParameterList()
      var day2 = new Date()
      day2.setTime(day2.getTime())
      var s2 = day2.getFullYear() + '-' + (day2.getMonth() + 1) + '-' + day2.getDate() + ' ' + day2.getHours() + ':' + day2.getMinutes() + ':' + day2.getSeconds()
      if (paramsRow && paramsRow.id) {
        this.formValidate = {
          id: paramsRow.id,
          cname: paramsRow.cname,
          code: paramsRow.code,
          adress: paramsRow.adress,
          legal: paramsRow.legal,
          legalcard: paramsRow.legalcard,
          capital: paramsRow.capital,
          stime: paramsRow.stime,
          etime: paramsRow.etime,
          authority: paramsRow.authority,
          atime: paramsRow.atime,
          licencecode: paramsRow.licencecode,
          villages: paramsRow.villages,
          linkman: paramsRow.linkman,
          linkphone: paramsRow.linkphone
        }
      } else {
        this.formValidate = {
          id: 0,
          cname: '',
          code: '',
          adress: '',
          legal: '',
          legalcard: '',
          capital: '',
          stime: s2,
          etime: s2,
          authority: '',
          atime: s2,
          licencecode: '',
          villages: '',
          linkman: '',
          linkphone: ''
        }
      }
    },
    handleSubmit (value) {
      this.$refs[value].validate((valid) => {
        if (valid) {
          setTimeout(() => {
            this.formValidate.stime = moment(this.formValidate.stime).utcOffset(480).format('YYYY-MM-DD HH:mm:ss')
            this.formValidate.etime = moment(this.formValidate.etime).utcOffset(480).format('YYYY-MM-DD HH:mm:ss')
            this.formValidate.atime = moment(this.formValidate.atime).utcOffset(480).format('YYYY-MM-DD HH:mm:ss')
            operationDispatchinfo(this.formValidate, this.editModalData).then(res => {
              if (res.data.code === 0) {
                this.$Message.success(`${res.data.msg}`)
                if (this.searchVal) {
                  this.getDispatchinfolist(this.searchVal)
                } else {
                  this.getDispatchinfolist()
                }
                this.modalMap.modalVisible = false
              } else {
                this.$Message.error(`${res.data.msg}`)
              }
            })
          }, 1000)
        } else {
          this.$Message.error('缺少必要参数')
        }
      })
    },
    handleReset (name) {
      this.$refs[name].resetFields()
    },
    handlerDelete () {
      if (this.tableSelectIdList.length > 0) {
        if (confirm(`确定要批量删除选中数据嘛？ `)) {
          operationDispatchinfo({ 'id_list': this.tableSelectIdList }, 'delete').then(res => {
            if (res.data.code === 0) {
              this.$Message.success(`${res.data.msg}`)
              this.getDispatchinfolist(this.searchVal)
            } else {
              this.$Message.error(`${res.data.msg}`)
            }
          })
        }
      } else {
        this.$Message.info(`你总要选中点什么吧`)
      }
    },
    delData (params) {
      if (confirm(`确定要删除该信息吗？`)) {
        operationDispatchinfo(
          {
            'id': params.row.id
          },
          'delete'
        ).then(res => {
          if (res.data.code === 0) {
            this.$Message.success(`${res.data.msg}`)
            this.tableData.splice(params.index, 1)
          } else {
            this.$Message.error(`${res.data.msg}`)
          }
        })
      }
    },
    changePage (value) {
      this.pageNum = value
      if (this.searchVal) {
        this.getDispatchinfolist(this.searchVal)
      } else {
        this.getDispatchinfolist()
      }
    },
    handlePageSize (value) {
      this.pageSize = value
      this.pageNum = 1
      if (this.searchVal) {
        this.getDispatchinfolist(this.searchVal)
      } else {
        this.getDispatchinfolist()
      }
    },
    searchinput () {
      if (this.searchVal) {
        this.getDispatchinfolist(this.searchVal)
      } else {
        this.getDispatchinfolist()
      }
    }
  },
  watch: {
    searchVal (val) {
      this.searchVal = val
    }
  },
  mounted () {
    this.getDispatchinfolist()
  }
}
</script>
<style lang="less" scoped>
.search-con {
  padding: 10px 0;

  .search {
    &-col {
      display: inline-block;
      width: 200px;
    }

    &-input {
      display: inline-block;
      width: 200px;
      margin-left: 2px;
    }

    &-btn {
      margin-left: 2px;
    }
  }
}
</style>
